import React from 'react';
import Grid from '@material-ui/core/Grid';
import MomentUtils from '@date-io/moment';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { useDispatch, useSelector } from 'react-redux';
import { setFilters } from 'redux/slices/dataSlice';
import { filterByOperationDateSelector } from 'redux/selectors';
import "moment/locale/es";

export default function MaterialUIPickers() {
  const dispatch = useDispatch();
  const selectedDate = useSelector(filterByOperationDateSelector) || null;
  // const [selectedDate, setSelectedDate] = useState(new Date(Date.now()));

  const handleDateChange = (date, value) => {
    dispatch(setFilters({ filterByOperationDate: value }));
  };

  return (
    <MuiPickersUtilsProvider locale={"es"} utils={MomentUtils}>
      <Grid>
        <KeyboardDatePicker
          variant="inline"
          format="YYYY/MM/DD"
          margin="dense"
          id="date-picker-inline"
          inputVariant="outlined"
          emptyLabel="Fecha de alta"
          value={selectedDate}
          onChange={handleDateChange}
          invalidDateMessage="Fecha no válida"
          disableFuture={true}
          maxDateMessage="No es posible elegir fechas futuras"
          mask="__/__/____"
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          autoOk={true}
          onError={(error, value) => {
            // check error display msg
          }}
        />
      </Grid>
    </MuiPickersUtilsProvider>
  );
}
